export const isLoaderTest = false;
export const allowedImageTypes = [
    'image/jpeg',
    'image/png',
    'image/gif',
];
export const themeLight = 'light';
